import {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {type IVIntent} from '@chekin/core';
import {useDocumentSelection as useSharedDocumentSelection} from '@chekin/shared/guest-form';
import {PATHS} from 'routes/constants';
import {usePath} from 'hooks';
import {getIVIntentRemoteSession} from 'hooks/iv/useIVRemoteSync';

type Props = {
  onSuccess?: (data: IVIntent) => void;
};
export const useDocumentSelection = ({onSuccess}: Props = {}) => {
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const goToUploading = useCallback(() => {
    navigate(getFullPath(PATHS.verification.front));
  }, [navigate, getFullPath]);

  return useSharedDocumentSelection({
    onSuccess,
    goToUploading,
    getIntentId: getIVIntentRemoteSession,
  });
};
